import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  CircularProgress,
  Paper,
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import { GetPrgrams } from "../../api";
import moment from 'moment';

const ProgramTable = ({program, setProgram}) => {

  const [pending, setPending] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [limit, setLimit] = React.useState(1000);
  const [page, setPage] = React.useState(0);

  React.useEffect(()=>{
    if(!pending){
      handleGetPrograms();
    }
  }, [])

  const { user } = useSelector(({ auth }) => auth, shallowEqual);



  const handleGetPrograms = async () => {
    setPending(true);
    try{
      console.log(user);
      let response = await GetPrgrams(user.organization, search, limit, page);
      setData(response.data.data.programs);
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false);
    }
  }

  const handleChange = (id) => {
    let tmp = [...program.recommended_programs];
    if(tmp.includes(id)){
      tmp = tmp.filter(p => p != id);
    }else{
      tmp.push(id)
    }
    // console.log(tmp)
    if(tmp.length > 3){
      alert('You can select upto 3 recommanded program');
      return ;
    }
    setProgram((pre)=>({
      ...pre,
      recommended_programs: [...tmp]
    }))
  }

  return (
    <TableContainer
      component={Paper}
      style={{ background: "transparent", boxShadow: "none !important" }}
    >
      <Typography variant="h3" align="center" gutterBottom className="mt-5">
        Select up to four
      </Typography>
      <Table>
        <TableHead>
          <TableRow style={{ background: "#F1F5F8" }}>
            <TableCell padding="checkbox"></TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Industry</TableCell>
            <TableCell>Cost</TableCell>
            <TableCell>Program Status</TableCell>
            <TableCell>Last Updated</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!pending && data.length > 0 && data.map((item, index) => (
            <TableRow key={index}>
              <TableCell padding="checkbox">
                <Checkbox checked={program.recommended_programs.includes(item._id)} onChange={()=>{handleChange(item._id)}} />
              </TableCell>
              <TableCell>{item.program_title}</TableCell>
              <TableCell>{item.industry_name}</TableCell>
              <TableCell>${item.total_cost}</TableCell>
              <TableCell>{item.program_status ? 'Enabled': 'Disabled'}</TableCell>
              <TableCell>{moment(item.updated_at).format("MM/DD/YYYY")}</TableCell>
            </TableRow>
          ))}
          {pending && <TableRow><TableCell align="center" colSpan={6}>
            <CircularProgress
                  size="20px"
                  style={{ color: "#3783e7" }}
                />
            </TableCell></TableRow>}
          {!pending && data.length == 0 && <TableRow><TableCell align="center" colSpan={6}>No Pragrams Available</TableCell></TableRow>}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProgramTable;
